
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { LayoutComponent } from './Layouts/layout/layout.component';
import { ShowErrorsComponent } from './Component/show-errors/show-errors.component';
import { DemoComponent } from './pages/demo/demo.component';
//import { AddBatchComponent } from './pages/batch/add-batch/add-batch.component';
//import { BatchListComponent } from './pages/batch/batch-list/batch-list.component';
import { GenerateCertificatesComponent } from './pages/generate-certificate/generate-certificates/generate-certificates.component';
import { GeneratedCertificateListComponent } from './pages/generate-certificate/generated-certificate-list/generated-certificate-list.component';
import { DownloadCertificateComponent } from './pages/download-certificate/download-certificate.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
   {
       path: '',
       component: LoginComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
      path: 'admin', component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'fonts',
        loadChildren: './pages/fonts/font.module#FontModule',
        data: {roles: ['Super Admin','Country Admin']},
        canActivateChild: [AuthGuard]
      },
      {
        path: 'template',
        loadChildren: './pages/certificates/certificates.module#CertificatesModule'
      },
      {
        path: 'user',
        loadChildren: './pages/users/users.module#UsersModule',
        data: { roles: ['Super Admin'] },
        canActivateChild: [AuthGuard]
      },
      //{
      //  path: 'batch',
      //  loadChildren: './pages/batch/batch.module#BatchModule'
      //},
      {
        path: 'school',
        loadChildren: './pages/schools/schools.module#SchoolsModule',
        data: { roles: ['Super Admin'] },
        canActivateChild: [AuthGuard]
      },
      {
        path: 'country',
        loadChildren: './pages/countries/countries.module#CountriesModule',
        data: { roles: ['Super Admin'] },
        canActivateChild: [AuthGuard]
      },
      {
        path: 'name-list',
        loadChildren: './pages/batch/batch.module#BatchModule'
      },
      {
        path: 'generated-certificate',
        loadChildren: './pages/generate-certificate/generate-certificate.module#GenerateCertificateModule'
      },

      {
        path: 'demo',
        component: DemoComponent
      },
       //{
       //  path: 'add-batch',
       //  component: AddBatchComponent
       //}
       //,
       //{
       //  path: 'edit-batch/:id',
       //  component: AddBatchComponent
       //},
       //{
       //  path: 'batch-list',
       //  component: BatchListComponent
       //},
      //{
      //  path: 'generate-certificate',
      //  component: GenerateCertificatesComponent
      //},
      //{
      //  path: 'generate-certificate/:id',
      //  component: GenerateCertificatesComponent
      //}
      //,
      //{
      //  path: 'generate-certificate-list',
      //  component: GeneratedCertificateListComponent
      //},
      {
        path: 'unauthorized',
        component: UnauthorizedComponent
      }      
    ]
  },
  {
    path: 'download-certificate/:id',
    component: DownloadCertificateComponent
  }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
  declarations: [],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
